module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    staticStyle: {
      "height": "5rem",
      "display": "block",
      "margin-top": "45%",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "src": "/emktResources/resocurces/img/logo2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips",
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": _vm.goWapp
    }
  }, [_vm._v("进入小程序")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28eaaa3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ToWapp.vue
// module id = 1575
// module chunks = 8